var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      class: {
        sidebar: true,
        sidebarStatic: _vm.sidebarStatic,
        sidebarOpened: _vm.sidebarOpened
      },
      on: {
        mouseenter: _vm.sidebarMouseEnter,
        mouseleave: _vm.sidebarMouseLeave
      }
    },
    [
      _c(
        "header",
        { staticClass: "logo" },
        [
          _c("router-link", { attrs: { to: "/app" } }, [
            _c("span", { staticClass: "text-warning" }, [_vm._v("Star")]),
            _vm._v("chase")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-3 pt-5" },
        [
          _c(
            "b-dropdown",
            {
              staticClass: "w-100",
              attrs: {
                text: _vm.searchSelect,
                id: "sidebarCountryDropdown",
                variant: "outline-warning",
                "no-caret": ""
              }
            },
            _vm._l(_vm.countries, function(country) {
              return _c(
                "b-dropdown-item",
                {
                  key: country.id,
                  staticClass: "w-100",
                  on: {
                    click: function($event) {
                      return _vm.changeCountry(country)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(country.name) + "\n        ")]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "nav" },
        [
          _c("h5", { staticClass: "navTitle mt-3" }, [_vm._v("Content")]),
          _vm._v(" "),
          _c("NavLink", {
            attrs: {
              activeItem: _vm.activeItem,
              header: "Behaviours",
              link: "/app/content/behaviours",
              iconName: "flaticon-star",
              index: "package",
              isHeader: ""
            }
          }),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Badges",
                  link: "/app/content/badges",
                  iconName: "flaticon-magic-wand",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Awards",
                  link: "/app/content/awards",
                  iconName: "flaticon-gift",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Notifications",
                  link: "/app/content/notifications",
                  iconName: "flaticon-alarm",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("h5", { staticClass: "navTitle" }, [_vm._v("Users")])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Leaderboard",
                  link: "/app/users/leaderboard",
                  iconName: "flaticon-idea",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("h5", { staticClass: "navTitle" }, [_vm._v("Admin console")])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Countries",
                  link: "/app/admin-console/countries",
                  iconName: "flaticon-flag-2",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Users",
                  link: "/app/admin-console/users",
                  iconName: "flaticon-users",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAdminRole()
            ? _c("NavLink", {
                attrs: {
                  activeItem: _vm.activeItem,
                  header: "Groups",
                  link: "/app/admin-console/groups",
                  iconName: "flaticon-users",
                  index: "package",
                  isHeader: ""
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }